module.exports = __webpack_public_path__ + "media/images/icons/outlined/picture-2829b684a72e6e2414a04bdc61e04b69.svg";